<template>
  <div class="d-flex align-items-center">
    <div class="side-frame-danger group-title">
      {{ $l('INDEX.form_label_bankAccountNo') || '银行账号' }}
    </div>
    <div>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-success"
        @click="$emit('openDetailDialog', { type: 'add' })"
        v-if="!disabled"
      >
        <b-icon-plus></b-icon-plus>
        {{ $l('INDEX.btn_add') || '添加' }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
